import React from 'react';
import { GuestProvider } from '../../context/GuestContext';
import GuestNav from './GuestNav';
import GuestHero from './GuestHero';
import GuestTrustModel from './GuestTrustModel';
import GuestThreePartModel from './GuestThreePartModel';
import GuestFeatures from './GuestFeatures';
import GuestStats from './GuestStats';
import GuestCTA from './GuestCTA';
import GuestRequestModal from './GuestRequestModal';

const Guest = () => (
  <GuestProvider>
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Roboto", sans-serif', overflowX: 'hidden' }}>
      <GuestNav />
      <GuestHero />
      <GuestTrustModel />
      <GuestThreePartModel />
      <GuestFeatures />
      <GuestStats />
      <GuestCTA />
      <GuestRequestModal />
    </div>
  </GuestProvider>
);

export default Guest;
